module.exports = {"id":"193953","name":"Abdoul Razzagui Camara","rating":"72","photo":"./data/images/photos/2/193953.png","club":{"name":"EA Guingamp","logo":"./data/images/clubs/EAGuingamp.png"},"positions":["AG","MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AbdoulRazzaguiCamara0.json
// module id = 57
// module chunks = 0